var exports = {
  "k": "xcc377c0b--126a57--container",
  "p": "xcc377c0b--126a57--info",
};

module.exports = exports;
